export const imports = {
  'getting-started.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "getting-started-docz" */ 'getting-started.docz.mdx'
    ),
  'versions.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "versions-docz" */ 'versions.docz.mdx'
    ),
  '1843/components/color/color-hsl.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "1843-components-color-color-hsl-docz" */ '1843/components/color/color-hsl.docz.mdx'
    ),
  '1843/components/color/color.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "1843-components-color-color-docz" */ '1843/components/color/color.docz.mdx'
    ),
  '1843/components/typography/typography.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "1843-components-typography-typography-docz" */ '1843/components/typography/typography.docz.mdx'
    ),
  'eiu/components/link/link.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "eiu-components-link-link-docz" */ 'eiu/components/link/link.docz.mdx'
    ),
  'common/components/actioned-link/actioned-link.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-actioned-link-actioned-link-docz" */ 'common/components/actioned-link/actioned-link.docz.mdx'
    ),
  'common/components/assets/assets.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-assets-assets-docz" */ 'common/components/assets/assets.docz.mdx'
    ),
  'common/components/badge/badge.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-badge-badge-docz" */ 'common/components/badge/badge.docz.mdx'
    ),
  'common/components/banner-alert/banner-alert.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-banner-alert-banner-alert-docz" */ 'common/components/banner-alert/banner-alert.docz.mdx'
    ),
  'common/components/blockquote/blockquote.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-blockquote-blockquote-docz" */ 'common/components/blockquote/blockquote.docz.mdx'
    ),
  'common/components/breadcrumb/breadcrumb.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-breadcrumb-breadcrumb-docz" */ 'common/components/breadcrumb/breadcrumb.docz.mdx'
    ),
  'common/components/button/button.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-button-button-docz" */ 'common/components/button/button.docz.mdx'
    ),
  'common/components/call-to-action/call-to-action.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-call-to-action-call-to-action-docz" */ 'common/components/call-to-action/call-to-action.docz.mdx'
    ),
  'common/components/call-to-action-with-arrow/call-to-action-with-arrow.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-call-to-action-with-arrow-call-to-action-with-arrow-docz" */ 'common/components/call-to-action-with-arrow/call-to-action-with-arrow.docz.mdx'
    ),
  'common/components/card/card.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-card-card-docz" */ 'common/components/card/card.docz.mdx'
    ),
  'common/components/chapter-list/chapter-list.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-chapter-list-chapter-list-docz" */ 'common/components/chapter-list/chapter-list.docz.mdx'
    ),
  'common/components/color/color-hsl.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-color-color-hsl-docz" */ 'common/components/color/color-hsl.docz.mdx'
    ),
  'common/components/color/color.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-color-color-docz" */ 'common/components/color/color.docz.mdx'
    ),
  'common/components/controls/control-close.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-controls-control-close-docz" */ 'common/components/controls/control-close.docz.mdx'
    ),
  'common/components/controls/control-collapse.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-controls-control-collapse-docz" */ 'common/components/controls/control-collapse.docz.mdx'
    ),
  'common/components/controls/control-drag-handle.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-controls-control-drag-handle-docz" */ 'common/components/controls/control-drag-handle.docz.mdx'
    ),
  'common/components/controls/control-drag.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-controls-control-drag-docz" */ 'common/components/controls/control-drag.docz.mdx'
    ),
  'common/components/controls/control-expand.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-controls-control-expand-docz" */ 'common/components/controls/control-expand.docz.mdx'
    ),
  'common/components/controls/control-label.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-controls-control-label-docz" */ 'common/components/controls/control-label.docz.mdx'
    ),
  'common/components/controls/control-media.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-controls-control-media-docz" */ 'common/components/controls/control-media.docz.mdx'
    ),
  'common/components/controls/tooltip.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-controls-tooltip-docz" */ 'common/components/controls/tooltip.docz.mdx'
    ),
  'common/components/emphasised-link/emphasised-link.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-emphasised-link-emphasised-link-docz" */ 'common/components/emphasised-link/emphasised-link.docz.mdx'
    ),
  'common/components/footer/footer-list.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-footer-footer-list-docz" */ 'common/components/footer/footer-list.docz.mdx'
    ),
  'common/components/footer/footer-secondary.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-footer-footer-secondary-docz" */ 'common/components/footer/footer-secondary.docz.mdx'
    ),
  'common/components/footer/footer.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-footer-footer-docz" */ 'common/components/footer/footer.docz.mdx'
    ),
  'common/components/forms/form-check-label.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-check-label-docz" */ 'common/components/forms/form-check-label.docz.mdx'
    ),
  'common/components/forms/form-checkbox.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-checkbox-docz" */ 'common/components/forms/form-checkbox.docz.mdx'
    ),
  'common/components/forms/form-field-combined-input.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-field-combined-input-docz" */ 'common/components/forms/form-field-combined-input.docz.mdx'
    ),
  'common/components/forms/form-field-date.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-field-date-docz" */ 'common/components/forms/form-field-date.docz.mdx'
    ),
  'common/components/forms/form-field-multiple-inputs.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-field-multiple-inputs-docz" */ 'common/components/forms/form-field-multiple-inputs.docz.mdx'
    ),
  'common/components/forms/form-field-number.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-field-number-docz" */ 'common/components/forms/form-field-number.docz.mdx'
    ),
  'common/components/forms/form-field-password.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-field-password-docz" */ 'common/components/forms/form-field-password.docz.mdx'
    ),
  'common/components/forms/form-field-search.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-field-search-docz" */ 'common/components/forms/form-field-search.docz.mdx'
    ),
  'common/components/forms/form-field-select.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-field-select-docz" */ 'common/components/forms/form-field-select.docz.mdx'
    ),
  'common/components/forms/form-field-text-area.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-field-text-area-docz" */ 'common/components/forms/form-field-text-area.docz.mdx'
    ),
  'common/components/forms/form-field-text.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-field-text-docz" */ 'common/components/forms/form-field-text.docz.mdx'
    ),
  'common/components/forms/form-helper-text.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-helper-text-docz" */ 'common/components/forms/form-helper-text.docz.mdx'
    ),
  'common/components/forms/form-input.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-input-docz" */ 'common/components/forms/form-input.docz.mdx'
    ),
  'common/components/forms/form-label.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-label-docz" */ 'common/components/forms/form-label.docz.mdx'
    ),
  'common/components/forms/form-notice.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-notice-docz" */ 'common/components/forms/form-notice.docz.mdx'
    ),
  'common/components/forms/form-radio-button.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-forms-form-radio-button-docz" */ 'common/components/forms/form-radio-button.docz.mdx'
    ),
  'common/components/grid/grid.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-grid-grid-docz" */ 'common/components/grid/grid.docz.mdx'
    ),
  'common/components/grid/layout-grid.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-grid-layout-grid-docz" */ 'common/components/grid/layout-grid.docz.mdx'
    ),
  'common/components/idents/ident-columns.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-idents-ident-columns-docz" */ 'common/components/idents/ident-columns.docz.mdx'
    ),
  'common/components/idents/ident-newsletters.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-idents-ident-newsletters-docz" */ 'common/components/idents/ident-newsletters.docz.mdx'
    ),
  'common/components/idents/ident-podcasts.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-idents-ident-podcasts-docz" */ 'common/components/idents/ident-podcasts.docz.mdx'
    ),
  'common/components/indicator/indicator.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-indicator-indicator-docz" */ 'common/components/indicator/indicator.docz.mdx'
    ),
  'common/components/inline-alert/inline-alert.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-inline-alert-inline-alert-docz" */ 'common/components/inline-alert/inline-alert.docz.mdx'
    ),
  'common/components/interactions/interactions.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-interactions-interactions-docz" */ 'common/components/interactions/interactions.docz.mdx'
    ),
  'common/components/link-with-arrow/link-with-arrow.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-link-with-arrow-link-with-arrow-docz" */ 'common/components/link-with-arrow/link-with-arrow.docz.mdx'
    ),
  'common/components/link-with-arrow-icon/link-with-arrow-icon.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-link-with-arrow-icon-link-with-arrow-icon-docz" */ 'common/components/link-with-arrow-icon/link-with-arrow-icon.docz.mdx'
    ),
  'common/components/masthead/account-login.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-masthead-account-login-docz" */ 'common/components/masthead/account-login.docz.mdx'
    ),
  'common/components/masthead/masthead-links.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-masthead-masthead-links-docz" */ 'common/components/masthead/masthead-links.docz.mdx'
    ),
  'common/components/masthead/masthead-logo.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-masthead-masthead-logo-docz" */ 'common/components/masthead/masthead-logo.docz.mdx'
    ),
  'common/components/masthead/masthead-navigation.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-masthead-masthead-navigation-docz" */ 'common/components/masthead/masthead-navigation.docz.mdx'
    ),
  'common/components/masthead/masthead-secondary.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-masthead-masthead-secondary-docz" */ 'common/components/masthead/masthead-secondary.docz.mdx'
    ),
  'common/components/masthead/masthead.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-masthead-masthead-docz" */ 'common/components/masthead/masthead.docz.mdx'
    ),
  'common/components/masthead/navigation-control.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-masthead-navigation-control-docz" */ 'common/components/masthead/navigation-control.docz.mdx'
    ),
  'common/components/masthead/navigation-list.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-masthead-navigation-list-docz" */ 'common/components/masthead/navigation-list.docz.mdx'
    ),
  'common/components/masthead/search-form.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-masthead-search-form-docz" */ 'common/components/masthead/search-form.docz.mdx'
    ),
  'common/components/media-promo/media-promo.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-media-promo-media-promo-docz" */ 'common/components/media-promo/media-promo.docz.mdx'
    ),
  'common/components/menu-disclosure/menu-disclosure.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-menu-disclosure-menu-disclosure-docz" */ 'common/components/menu-disclosure/menu-disclosure.docz.mdx'
    ),
  'common/components/missed-target/missed-target.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-missed-target-missed-target-docz" */ 'common/components/missed-target/missed-target.docz.mdx'
    ),
  'common/components/navigation-disclosure/navigation-disclosure.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-navigation-disclosure-navigation-disclosure-docz" */ 'common/components/navigation-disclosure/navigation-disclosure.docz.mdx'
    ),
  'common/components/notification/notification.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-notification-notification-docz" */ 'common/components/notification/notification.docz.mdx'
    ),
  'common/components/navigation-link/navigation-link.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-navigation-link-navigation-link-docz" */ 'common/components/navigation-link/navigation-link.docz.mdx'
    ),
  'common/components/pagination/pagination.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-pagination-pagination-docz" */ 'common/components/pagination/pagination.docz.mdx'
    ),
  'common/components/podcast-card/podcast-card.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-podcast-card-podcast-card-docz" */ 'common/components/podcast-card/podcast-card.docz.mdx'
    ),
  'common/components/pullquote/pullquote.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-pullquote-pullquote-docz" */ 'common/components/pullquote/pullquote.docz.mdx'
    ),
  'common/components/rule/rule.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-rule-rule-docz" */ 'common/components/rule/rule.docz.mdx'
    ),
  'common/components/section-control/section-control.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-section-control-section-control-docz" */ 'common/components/section-control/section-control.docz.mdx'
    ),
  'common/components/section-headline/section-headline.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-section-headline-section-headline-docz" */ 'common/components/section-headline/section-headline.docz.mdx'
    ),
  'common/components/section-link/section-link.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-section-link-section-link-docz" */ 'common/components/section-link/section-link.docz.mdx'
    ),
  'common/components/share/share.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-share-share-docz" */ 'common/components/share/share.docz.mdx'
    ),
  'common/components/share-link/share-link.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-share-link-share-link-docz" */ 'common/components/share-link/share-link.docz.mdx'
    ),
  'common/components/slim-button/slim-button.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-slim-button-slim-button-docz" */ 'common/components/slim-button/slim-button.docz.mdx'
    ),
  'common/components/slim-media-promo/slim-media-promo.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-slim-media-promo-slim-media-promo-docz" */ 'common/components/slim-media-promo/slim-media-promo.docz.mdx'
    ),
  'common/components/stage-banner/stage-banner.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-stage-banner-stage-banner-docz" */ 'common/components/stage-banner/stage-banner.docz.mdx'
    ),
  'common/components/status-alert/status-alert.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-status-alert-status-alert-docz" */ 'common/components/status-alert/status-alert.docz.mdx'
    ),
  'common/components/tables/table-collapse.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-tables-table-collapse-docz" */ 'common/components/tables/table-collapse.docz.mdx'
    ),
  'common/components/tables/table.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-tables-table-docz" */ 'common/components/tables/table.docz.mdx'
    ),
  'common/components/tabs/tabs.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-tabs-tabs-docz" */ 'common/components/tabs/tabs.docz.mdx'
    ),
  'common/components/card/action/action.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-card-action-action-docz" */ 'common/components/card/action/action.docz.mdx'
    ),
  'common/components/card/content/content.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-card-content-content-docz" */ 'common/components/card/content/content.docz.mdx'
    ),
  'common/components/card/description/description.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-card-description-description-docz" */ 'common/components/card/description/description.docz.mdx'
    ),
  'common/components/card/headline/headline.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-card-headline-headline-docz" */ 'common/components/card/headline/headline.docz.mdx'
    ),
  'common/components/card/image/image.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-card-image-image-docz" */ 'common/components/card/image/image.docz.mdx'
    ),
  'common/components/card/link/link.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-card-link-link-docz" */ 'common/components/card/link/link.docz.mdx'
    ),
  'common/components/card/sub-headline/sub-headline.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-card-sub-headline-sub-headline-docz" */ 'common/components/card/sub-headline/sub-headline.docz.mdx'
    ),
  'common/components/controls/control-check/control-check.docz.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "common-components-controls-control-check-control-check-docz" */ 'common/components/controls/control-check/control-check.docz.mdx'
    ),
}
